<div class="order-status" [ngClass]="config.class">
  {{ config.status }}
</div>